<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-06-01 08:57:21
 * @LastEditors: WangYuan
 * @LastEditTime: 2025-05-26
-->
<template>
  <div>
    <div style="display: flex; align-items: center" class="mb20">
      <div class="w120 f13 f-grey pl12 mr10 lh-28">
        {{ label }}
      </div>
      <div style="flex: 1">
        <el-select
            style="width: 100%"
            v-model="tagSource"
            size="small"
            @change="change"
        >
          <el-option
              v-for="(item, index) in tagList"
              :key="index"
              :label="item.name"
              :value="item.url"
          />
        </el-select>
      </div>
    </div>

    <!-- 请求参数 -->
    <div v-if="mValue.paramsData.length > 0 && loadParamsData"
         class="flex_box" style="display:none;">
      <div class="w120 f13 f-grey pl12 mr10 lh-28">请求参数</div>
      <div>
        <div
            class="mt10 mb10"
            v-for="(item, index) in mValue.paramsData"
            :key="index"
        >
          <div class="flex_box" v-if="item.type == 'helper'">
            <div class="f-grey f13 w120">{{ item.sourceName }}</div>
            <el-select
                style="width: 100%"
                v-model="mValue.paramsDataSelect[item.source]"
                size="small"
                @change="(value) => getChangeValue(value, item.source)"
                clearable
            >
              <el-option
                  v-for="(item2, index2) in item.params.list"
                  :key="index2"
                  :label="item2.name"
                  :value="item2.value"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div
        v-if="roleList.length > 0"
        style="display: flex; align-items: center"
        class="mb20"
    >
      <div class="w120 f13 f-grey pl12 mr10 lh-28">配置角色</div>
      <div style="flex: 1" v-if="roleList.length > 0">
        <el-select
            v-model="mValue.role"
            multiple
            size="mini"
            placeholder="配置角色"
            style="width: 100%"
        >
          <el-option
              v-for="item in roleList"
              :key="item.sign"
              :label="item.name"
              :value="item.sign"
          >
          </el-option>
        </el-select>
      </div>
      <div v-else class="f13 f-grey">未配置角色信息</div>
    </div>

    <!-- 控制展示内容 -->
    <div v-if="mValue.isConDisContent" style="display: flex">
      <div class="w120 f13 f-grey pl12 mr10 lh-28">{{ mValue.title }}</div>
      <div style="flex: 1">
        <el-checkbox-group v-model="mValue.displayContent">
          <el-checkbox
              :label="item.target"
              :value="item.target"
              v-for="(item, index) in dataList"
              v-if="item.target != 'keyword' && item.target != 'paramsData'"
              :key="item.target || index"
          >
            {{ item.targetName ? item.targetName : item.sourceName }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <!-- 控制展示内容 是否支持搜索-->
    <div v-if="mValue.isSupportFilter">
      <div style="display: flex" class="mt15">
        <div class="w120 f13 f-grey pl12 mr10 lh-28">筛选项</div>
        <div style="flex: 1">
          <div
              class="mode-select-item flex-center"
              :class="[
              item.value == mValue.isShowFilter
                ? 'mode-select-item-active'
                : '',
            ]"
              v-for="(item, index) in filterList"
              :key="index"
              @click="clickItem(item)"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
      <div v-if="mValue.isShowFilter"></div>
    </div>

    <!-- 选择分类 -->
    <div
        v-if="mValue.isShowClass && isShowListClass"
        class="flex mt20 mb10"
    >
      <div class="w120 f13 f-grey pl12 mr10 lh-28" >选择分类</div>
      <el-button @click="showClassPopup" size="mini" type="primary"
      >
        {{mValue.selectClass&&mValue.selectClass?.length && mValue.selectClass.some(c => c[c.relationField]) ? '修改分类' : '选择分类'}}
      </el-button>
    </div>

    <el-dialog
        v-if="showClass"
        title="选择分类"
        :visible.sync="showClass"
        width="30%"
    >
      <el-tabs type="border-card">
        <el-tab-pane
            :label="item.title"
            v-for="(item, index) in dsInitParams"
            :key="index"
        >
          <div class="points-tit mb10">
            选择{{ item.title ? item.title : "" }}({{
              item.required ? "必填" : "非必填"
            }})
          </div>

          <div
              v-if="item.paramType != 'dict'"
              style="height: 400px; overflow-x: hidden; overflow-y: auto"
          >
            <el-tree
                ref="tree"
                :data="item.dataList"
                show-checkbox
                check-on-click-node
                default-expand-all
                :node-key="item.relationField"
                highlight-current
                max-height="500"
                :props="{
                children: item.dataMapper.children.source,
                label: 'name',
              }"
                @check="
                (node, checkedNode) =>
                  handleCheckChange(node, checkedNode, item, index)
              "
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <div>
                  <i
                      :style="
                      treeSelect.includes(data[item.relationField])
                        ? 'color:#1684FC'
                        : ''
                    "
                      v-if="
                      data[item.dataMapper.children.source] &&
                      data[item.dataMapper.children.source].length > 0
                    "
                      class="el-icon-folder-opened mr10"
                  ></i>
                  <i
                      v-else
                      :style="
                      treeSelect.includes(data[item.relationField])
                        ? 'color:#1684FC'
                        : ''
                    "
                      class="el-icon-document mr10"
                  ></i>
                  <span
                      :style="
                      treeSelect.includes(data[item.relationField])
                        ? 'color:#1684FC'
                        : ''
                    "
                  >{{ node.label }}</span
                  >
                </div>
              </span>
            </el-tree>
          </div>

          <div v-else>
            <el-table
                ref="insidTable"
                :data="item.dataList"
                :row-key="getRowKey"
                class="insidTab"
                size="mini"
                stripe
                max-height="500"
                :show-header="false"
            >
              <el-table-column
                  align="center"
                  reserve-selection
                  type="selection"
                  width="55"
              >
                <template slot-scope="scope">
                  <input
                      type="checkBox"
                      :checked="scope.row[item.relationField] == item.curChoose"
                      @click="
                      btnClickParams(index, scope.row[item.relationField])
                    "
                  />
                </template>
              </el-table-column>

              <el-table-column
                  :label="items.targetName"
                  :prop="items.source"
                  class-name="custom-cell"
                  v-for="(items, indexs) in item.dataMapper"
                  :key="indexs"
              >
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button size="small" @click="showClass = false">取消</el-button>
        <el-button size="small" type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import {
  comDSList,
  getDatasourceList,
  getRuleList,
} from "../../../api/easyApp";
import { mapGetters } from "vuex";
import { deepClone } from "../../../js/utils";
import {
  getCategoryList,
  datasourcePage,
  getCategoryListPost,
  getDatasourceByDsId,
  getDatasourceByUrl,
} from "@/api/easyApp";

export default {
  name: "SchemaTagSource",
  mixins: [schemaMixin],
  props: {
    labelSwitch: {
      default: true,
    },
    isShow: {
      default: true,
    },
    tagCategory: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: {},
    },
  },

  inject: ["mode"],

  data() {
    return {
      tagSource: "",
      showClass: false,
      defaultOptions: {
        trueLabel: "显示",
        falseLabel: "隐藏",
      },
      tagList: [],
      roleList: [],
      valueNew: "",
      dataList: [],
      decRule: [],
      searchRuleSign: "",
      filterList: [
        { label: "显示", value: "0" },
        { label: "不显示", value: "1" },
      ],
      selectClass: [],
      treeSelect: [],
      dsInitParams: [],
      paramsSelectList: [],
      loadParamsData: false,
    };
  },
  computed: {
    ...mapGetters(["project"]),
    isShowListClass() {
      if (!this.tagList || !this.tagSource) return false;
      const table_index = this.tagList.findIndex(item => item.url === this.tagSource);
      const targetItem = this.tagList[table_index];
      if (!targetItem) return false;
      return !!targetItem.relationParams || !!targetItem.params;
    },
  },
  async created() {
    // 全局安全JSON解析
    const safeParse = (str) => {
      if (!str) return [];
      try {
        return JSON.parse(str.replace(/[\n\r\t]/g, "").trim());
      } catch (e) {
        return [];
      }
    };

    let res1 = await getRuleList([this.tagCategory]);
    this.decRule = safeParse(res1.data?.[0]?.ruleData);
    this.mValue.decRule = safeParse(res1.data?.[0]?.ruleData);
    let data = { tags: this.tagCategory };

    let res = await getDatasourceList(data);
    this.tagList = res.data || [];
    if (this.mValue.tagSource) {
      this.tagSource = this.mValue.tagSource.split("?")[0];
      let index = this.tagList.findIndex((item) => item.url == this.tagSource);
      if (index != -1) {
        this.getParseRoleList(index);
        this.mValue.businessGroup = this.tagList[index].dataMapperList?.[0]?.businessGroup || "";
        const configContent = safeParse(this.tagList[index].dataMapperList?.[0]?.configContent);

        if (!Array.isArray(configContent)) {
          let configContentNew = [];
          let paramsData = [];
          if (configContent.paramsData) {
            for (let i in configContent.paramsData) {
              paramsData.push({ target: i, ...configContent.paramsData[i] });
            }
            this.mValue.paramsData = deepClone(paramsData);
            this.loadParamsData = false;
            this.mValue.paramsData.forEach(async (item, index) => {
              if (item.type && item.type == "helper") {
                if (item.params.type == "remoto") {
                  let res = await getDatasourceByDsId(item.params.value);
                  getDatasourceByUrl(res.data.url).then((result) => {
                    if (result.code == 0) {
                      item.params.list = result.data.map((ele) => ({
                        name: ele.name,
                        value: ele[item.target],
                      }));
                    }
                  });
                }
                if (!this.mValue.paramsDataSelect?.[item.source]) {
                  this.mValue.paramsDataSelect[item.source] = "";
                }
              }
              if (index == this.mValue.paramsData.length - 1) {
                setTimeout(() => { this.loadParamsData = true; }, 1000);
              }
            });
          } else {
            this.mValue.paramsData = [];
          }

          for (const i in configContent) {
            if (i != "paramsData") {
              let obj = configContent[i];
              obj["target"] = i;
              obj["targetName"] = configContent[i].sourceName;
              configContentNew.push(obj);
            }
          }
          this.mValue.dataMapper = deepClone(configContentNew);
          this.dataList = configContentNew.filter((item) => item.target != "keyword");
        } else {
          this.mValue.dataMapper = deepClone(configContent);
          let dataList = deepClone(configContent);
          this.dataList = dataList.filter((item) => item.target != "keyword");
        }

        if (this.mValue.isSupportSearch == true) {
          let index = this.mValue.dataMapper.findIndex((item) => item.target == "keyword");
          if (index != -1) {
            this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
          }
        }
        this.mValue.relationParams = this.tagList[index].params || "";
      } else {
        this.getParseRoleList(0);
      }
    } else {
      this.mValue.tagSource = this.tagList[0]?.url || "";
      this.mValue.businessGroup = this.tagList[0]?.dataMapperList?.[0]?.businessGroup || "";
      this.getParseRoleList(0);
      const configContent = safeParse(this.tagList[0]?.dataMapperList?.[0]?.configContent);

      if (!Array.isArray(configContent)) {
        let configContentNew = [];
        let paramsData = [];
        if (configContent.paramsData) {
          for (let i in configContent.paramsData) {
            paramsData.push({ target: i, ...configContent.paramsData[i] });
          }
          this.mValue.paramsData = deepClone(paramsData);
          this.mValue.paramsDataSelect = {};
          this.loadParamsData = false;
          this.mValue.paramsData.forEach(async (item, index) => {
            if (item.type && item.type == "helper") {
              if (item.params.type == "remoto") {
                let res = await getDatasourceByDsId(item.params.value);
                getDatasourceByUrl(res.data.url).then((result) => {
                  if (result.code == 0) {
                    item.params.list = result.data.map((ele) => ({
                      name: ele.name,
                      value: ele[item.target],
                    }));
                  }
                });
              }
              this.mValue.paramsDataSelect[item.source] = "";
            }
            if (index == this.mValue.paramsData.length - 1) {
              setTimeout(() => { this.loadParamsData = true; }, 1000);
            }
          });
        } else {
          this.mValue.paramsData = [];
        }

        for (const i in configContent) {
          if (i != "paramsData") {
            let obj = configContent[i];
            obj["target"] = i;
            obj["targetName"] = configContent[i].sourceName;
            configContentNew.push(obj);
          }
        }
        this.mValue.dataMapper = deepClone(configContentNew);
        this.mValue.relationParams = this.tagList[0]?.params || "";
        this.dataList = configContentNew.filter((item) => item.target != "keyword");
      } else {
        this.mValue.dataMapper = deepClone(configContent);
        this.mValue.relationParams = this.tagList[0]?.params || "";
        let dataList = deepClone(configContent);
        this.dataList = dataList.filter((item) => item.target != "keyword");
      }

      if (this.mValue.isSupportSearch == true) {
        let index = this.mValue.dataMapper.findIndex((item) => item.target == "keyword");
        if (index != -1) {
          this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
        }
      }

      let displayContent = [];
      for (const i in this.mValue.dataMapper) {
        displayContent.push(this.mValue.dataMapper[i].target);
      }
      this.mValue.displayContent = displayContent;
    }
    this.tagSource = this.mValue.tagSource?.split("?")[0] || "";


    console.log("this.mValue:",this.mValue);


  },

  methods: {
    getRowKey(row) { return row.pagesId; },
    cellClass(row) { return row.columnIndex === 0 ? "disabledCheck" : ""; },
    getChangeValue(value, source) {
      this.mValue[source] = value;
      this.$forceUpdate();
    },
    handleCheckChange(data, checkedNode, item, index) {
      if (this._treeCheckLock) {
        console.log("===handleCheckChange=== locked, returning");
        return;
      }
      console.log("===handleCheckChange=== index:", index, "data:", JSON.stringify(data));
      console.log("===handleCheckChange=== checkedNode.checkedKeys:", checkedNode.checkedKeys);
      console.log("===handleCheckChange=== item:", JSON.stringify(item));
      if (item && item.multiValue) {
        const id = item.concatType == "CONCAT"
            ? checkedNode.checkedKeys.join(item.concatChar)
            : JSON.stringify(checkedNode.checkedKeys);
        this.treeSelect = checkedNode.checkedKeys;
        this.btnClickParams(index, id);
      } else {
        const nodeKey = data[item.relationField];
        const isChecked = checkedNode.checkedKeys.includes(nodeKey);
        console.log("===handleCheckChange=== nodeKey:", nodeKey, "isChecked:", isChecked);
        this._treeCheckLock = true;
        if (isChecked) {
          this.$refs.tree[index]?.setCheckedKeys([nodeKey]);
          this.btnClickParams(index, nodeKey);
          this.treeSelect = [nodeKey];
        } else {
          this.$refs.tree[index]?.setCheckedKeys([]);
          this.dsInitParams[index].curChoose = "";
          this.treeSelect = [];
          this.btnClickParams(index, "");
        }
        this.$nextTick(() => { this._treeCheckLock = false; });
      }
    },
    btnClickParams(index, id) {
      const componentId = this.dsInitParams[index].name;
      console.log("===btnClickParams=== index:", index, "id:", JSON.stringify(id), "componentId:", componentId);
      console.log("===btnClickParams=== selectClass before:", JSON.stringify(this.selectClass));

      let index1 = this.selectClass?.findIndex(item =>
        item.componentId == componentId ||
        (item.componentId && item.componentId.indexOf(componentId) !== -1)
      ) ?? -1;
      console.log("===btnClickParams=== found index1:", index1);

      const relationField = this.dsInitParams[index].relationField;
      const existingValue = index1 !== -1 ? this.selectClass[index1][relationField] : null;
      console.log("===btnClickParams=== existingValue:", JSON.stringify(existingValue));

      if (index1 !== -1 && existingValue === id) {
        console.log("===btnClickParams=== same value, removing");
        this.selectClass.splice(index1, 1);
        this.dsInitParams[index].curChoose = "";
        console.log("===btnClickParams=== selectClass after:", JSON.stringify(this.selectClass));
        return;
      }

      this.dsInitParams[index].curChoose = id;

      if (id === "" || id === null || id === undefined) {
        console.log("===btnClickParams=== id is empty, removing from selectClass");
        if (index1 !== -1) {
          this.selectClass.splice(index1, 1);
        }
        console.log("===btnClickParams=== selectClass after:", JSON.stringify(this.selectClass));
        return;
      }

      const obj = {
        componentId,
        relationField,
        name: this.dsInitParams[index].name,
        paramType: this.dsInitParams[index].paramType,
        showType: this.dsInitParams[index].showType,
      };
      obj[relationField] = id;
      if (index1 !== -1) {
        this.selectClass[index1] = deepClone(obj);
      } else {
        this.selectClass.push(obj);
      }
      console.log("===btnClickParams=== selectClass after:", JSON.stringify(this.selectClass));
    },
    submit() {
      console.log("===submit=== START ===");
      console.log("===submit=== selectClass:", JSON.stringify(this.selectClass));
      console.log("===submit=== mValue.selectClass:", JSON.stringify(this.mValue.selectClass));
      let url = this.tagSource;
      this.selectClass.forEach((item, index) => {
        url += index == 0 ? `?${item.name}=${item[item.relationField]}` : `&${item.name}=${item[item.relationField]}`;
      });
      this.mValue.selectClass = deepClone(this.selectClass);
      this.mValue.tagSource = url;
      this.showClass = false;
      console.log("===submit=== END ===");
    },
    select(row) {
      const index1 = this.checkObjs.findIndex(item => item == row[this.dataMapper.id]);
      index1 != -1 ? this.checkObjs.splice(index1, 1) : this.checkObjs.push(row[this.dataMapper.id]);
    },
    async getInitData(obj, url, method) {
      const data = { current: obj.current, size: obj.size, url };
      if (method?.toUpperCase() == "POST") return (await getCategoryListPost(data)).data;
      return (await getCategoryList(data)).data;
    },
    async showClassPopup() {

      // 全局安全JSON解析
      const safeParse = (str) => {
        if (!str) return [];
        try {
          return JSON.parse(str.replace(/[\n\r\t]/g, "").trim());
        } catch (e) {
          return [];
        }
      };




      this.checkObjs = [];
      this.dataMapper = [];
      const table_index = this.tagList.findIndex(item => item.url == this.tagSource);
      const targetItem = this.tagList[table_index];
      if (!targetItem) {
        this.$message({ message: "未查询到分类", type: "error" });
        return false;
      }
      const relationParams = safeParse(targetItem.params || targetItem.relationParams);
      const ds_Name = targetItem.params ? "dsName" : "relationDS";
      const ds_Field = targetItem.params ? "dsField" : "relationField";
      const dict_Ds = targetItem.params ? "dictDs" : "dictDS";
      const dict = relationParams.filter(item => item.paramType == "dict");
      const normalParams = relationParams.filter(item => item.paramType != "dict");

      let code = [];
      let initList = [];
      normalParams.forEach(item => {
        code.push(item[ds_Name]);
        const dataMapper = safeParse(targetItem.dataMapperList[0]["configContent"]);
        initList.push({
          code: item[ds_Name],
          dataMapper,
          name: item["name"],
          relationField: item[ds_Field],
          dataList: [],
          required: item.required,
          multiValue: item.multiValue,
          concatType: item.concatType,
          concatChar: item.concatChar,
          paramType: item.paramType,
          title: "",
        });
      });
      const initDictList = dict.map(item => ({
        dataMapper: { label: { source: "label", sourceName: item[dict_Ds].name } },
        name: item.name,
        relationField: "value",
        required: item.required,
        dataList: safeParse(item[dict_Ds].items),
        title: item[dict_Ds].name,
        paramType: item.paramType,
        curChoose: "",
      }));

      const res = await datasourcePage({ codes: code.toString(), current: 1, size: 100 });
      const records = res.data.records || [];
      for (const i in initList) {
        const obj = { current: 1, size: 10, dataList: [], pages: 0, code: records[i]?.code, total: 0 };
        const result = await this.getInitData(obj, records[i]?.url, records[i]?.method);
        initList[i].dataList = result;
        initList[i].showType = records[i]?.showType;
        initList[i].title = records[i]?.name;
      }
      this.dsInitParams = [...initList, ...initDictList];
      this.showClass = true;
      this.$nextTick(() => {
        this.dsInitParams.forEach((item2, index2) => {
          if (item2.showType == "show_tree") {
            this.$refs.tree[index2]?.setCheckedKeys([]);
          }
        });
        this.mValue.selectClass.forEach((item) => {
          if (item.paramType == "dict") {
            this.dsInitParams.forEach((item2, index2) => {
              if (item2.name == item.name) this.dsInitParams[index2].curChoose = item[item.relationField];
            });
          } else {
            this.dsInitParams.forEach((item2, index2) => {
              if (item2.showType == "show_tree" && item2.name == item.name) {
                const arr = item[item.relationField]?.split(",") || [];
                this.$refs.tree[index2]?.setCheckedKeys(arr);
              }
            });
          }
        });
        this.selectClass = deepClone(this.mValue.selectClass);
      });
    },
    getParseRoleList(index) {
      const item = this.tagList[index];
      if (!item || !item.roles) {
        this.roleList = [];
        return;
      }
      try {
        const { rolesName, rolesSign } = safeParse(item.roles);
        this.roleList = rolesName.map((name, i) => ({ name, sign: rolesSign[i] }));
      } catch (e) {
        this.roleList = [];
      }
    },
    getName(target) {
      const index = this.decRule.findIndex(item => item.sign == target);
      return index != -1 ? this.decRule[index].name : "";
    },
    change(val) {

      // 全局安全JSON解析
      const safeParse = (str) => {
        if (!str) return [];
        try {
          return JSON.parse(str.replace(/[\n\r\t]/g, "").trim());
        } catch (e) {
          return [];
        }
      };



      this.mValue.tagSource = this.tagSource;
      const index = this.tagList.findIndex(item => item.url == val);


      if (index != -1) {
        if (this.mValue.tagSource.split("?")[0] != val && this.mValue.isShowClass) {
          this.selectClass = [];
          this.mValue.selectClass = [];
        }
        this.getParseRoleList(index);
        this.mValue.role = [];
        this.mValue.businessGroup = this.tagList[index].dataMapperList?.[0]?.businessGroup || "";
        const configContent = safeParse(this.tagList[index].dataMapperList?.[0]?.configContent);
        if (!Array.isArray(configContent)) {
          let paramsData = [];

          if (configContent.paramsData) {
            for (let i in configContent.paramsData) {
              paramsData.push({ target: i, ...configContent.paramsData[i] });
            }
            this.mValue.paramsData = deepClone(paramsData);
            this.mValue.paramsDataSelect = {};
            this.loadParamsData = false;
            this.mValue.paramsData.forEach(async (item, index) => {
              if (item.type && item.type == "helper") {
                if (item.params.type == "remoto") {
                  let res = await getDatasourceByDsId(item.params.value);
                  getDatasourceByUrl(res.data.url).then((result) => {
                    if (result.code == 0) {
                      item.params.list = result.data.map((ele) => ({
                        name: ele.name,
                        value: ele[item.target],
                      }));
                    }
                  });
                }
                this.mValue.paramsDataSelect[item.source] = "";
              }
              if (index == this.mValue.paramsData.length - 1) {
                setTimeout(() => { this.loadParamsData = true; }, 1000);
              }
            });
          } else {
            this.mValue.paramsData = [];
          }



          let configContentNew = [];
          for (const i in configContent) {
            if (i != "paramsData") {
              let obj = configContent[i];
              obj["target"] = i;
              obj["targetName"] = configContent[i].sourceName;
              configContentNew.push(obj);
            }
          }
          this.mValue.dataMapper = deepClone(configContentNew);
          this.dataList = configContentNew.filter((item) => item.target != "keyword");
        } else {
          this.mValue.dataMapper = deepClone(configContent);
          let dataList = deepClone(configContent);
          this.dataList = dataList.filter((item) => item.target != "keyword");
        }


        if (this.mValue.isSupportSearch == true) {
          const index1 = this.mValue.dataMapper.findIndex(item => item.target == "keyword");
          if (index1 != -1) this.mValue.realSearchSign = this.mValue.dataMapper[index1].source;
        }
        this.$forceUpdate();
        const displayContent = [];
        for (const i in this.mValue.dataMapper) displayContent.push(this.mValue.dataMapper[i].target);
        this.mValue.displayContent = displayContent;
        this.mValue.relationParams = this.tagList[index].params || "";
      } else {
        this.mValue.displayContent = [];
        this.mValue.relationParams = "";
        this.mValue.realSearchSign = "";
      }



    },
    clickItem(item) { this.mValue.isShowFilter = item.value; },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 25px;
  .wrap-label { font-size: 14px; line-height: 32px; }
  .flex_box { display: flex; align-items: center; justify-content: space-between; }
}
</style>